import { Box, Button, Chip, Divider, Grid, Link, Typography  } from '@mui/material'
import { useAppDispatch, useAppSelector } from '../../Redux/store';
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetJobsByStatusQuery, useUpdateJobMutation } from '../../Redux/api/jobApi';
import { KaziAvatar } from '../../Shared Components/Kazi/KaziAvatar';
import moment from 'moment';
import { formatUserName } from '../../Utils/String';
import { QueryBuilderOutlined } from '@mui/icons-material';
import { useToast } from '../../Hooks/useToast';
import { JobCompletionModal } from './Components/JobCompletionModal';
import { Fragment, ReactNode, useState } from 'react';
import { IJobByStatus, Job } from '../../Types/Job';
import { KaziLayout } from '../../Shared Components/Kazi/Layouts/KaziLayout';
import { useUser } from '../../Hooks/useUser';
import { ProfileType } from '../../Types/General';
import { ActiveJobView } from './Components/ActiveJobView';

interface IActiveJob {
    title: string;
    jobs: any[];
}

export const ActiveJobs = () => {
    /* ******************** Hooks ******************** */
    const { user } = useUser();
    const {
        data: jobs, 
        isLoading: jobsLoading, 
        isFetching: jobsFetching
    } = useGetJobsByStatusQuery(user?.locator && {locator: user?.locator!, statuses: 'in_progress,ready_for_review,finished'} || skipToken)
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const getJobs = () =>{
        let activeJobs: IActiveJob[] = [
            {title: 'Active short-term jobs', jobs: []},
            {title: 'Active full-time jobs', jobs: []},
            {title: 'Active internships', jobs: []},
            {title: 'Previous jobs', jobs: []},
        ]
        if (jobs) {
            //@ts-ignore
            jobs?.forEach(job =>{
                if (job.status == 'finished') {
                    activeJobs[3].jobs.push(job) 
                    return
                } 
                switch(job.type) {
                    case 'Short-term':
                        activeJobs[0].jobs.push(job);
                        break;
                    case 'Full-time':
                        activeJobs[1].jobs.push(job);
                        break;
                    case 'Internship':
                        activeJobs[2].jobs.push(job);
                        break;
    
                }
                // Add logic for previous jobs
            })
            return activeJobs;
        }
        return []
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <KaziLayout>
                <Grid display={'flex'} flexDirection={'column'} gap={'60px'}>
                    {
                        getJobs().map((job, idx) => (
                            <Grid  display={'flex'} flexDirection={'column'}>
                                <Typography variant='lora-headline-small' color={'text.primary'} marginBottom={'30px'}>{job.title}</Typography>
                                    {
                                        job.jobs.map( (j: IJobByStatus )=> (       
                                            <Fragment key={j.locator}>                          
                                                <ActiveJobView 
                                                    job={j}
                                                />
                                                <Divider />
                                            </Fragment>       
                                        ))                                    
                                    }
                                    {
                                        
                                        job.jobs.length === 0 &&
                                        <Grid display={'flex'} flexDirection={'row'} justifyContent={'center'} alignItems={'center'}>
                                            <QueryBuilderOutlined sx={{color: 'green.200', fontSize: '24px', marginRight: 1}} />
                                            <Typography>No {job.title.toLowerCase()}</Typography>
                                        </Grid>
                                    }
                            </ Grid>
                        ))
                    }                
                </Grid>   
            </ KaziLayout>
        </>
    )
}